import React, { Component } from 'react';
import ConfirmOTP from './ConfirmOTP'

// import  {SignUpActions} from '../../../../store'

import {connect} from 'react-redux'
/**
 * ConfirmOTPContainer connects all the redux store and action to post sign up component
 */
class ConfirmOTPContainer extends Component {
    render(){
       return( <ConfirmOTP  {...this.props}/>);
    }

}



const mapDispatchToProps = (dispatch,ownProps) => {
    return {
        //signUp:(data)=>SignUpActions.signUp(data,dispatch),
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        signUpInProgress: state.signUp.signUpInProgress,
        storeUser:state.signUp.storeUser,
        data:state.signUp.data,
        user:state.cognito.user,
        attributes:state.cognito.attributes
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(ConfirmOTPContainer);